export default "__VITE_ASSET__DNG02f7i__"